import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Typography, IconButton, useTheme, Skeleton, MenuItem, Select, FormControl, Button } from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import { DiffEditor, Editor } from "@monaco-editor/react";
import { format } from 'date-fns';
import axiosInstance from '../../../axios/axios';
import { END_POINTS } from '../../../shared';
import type { editor } from 'monaco-editor';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/store';
import { clearConfigDiffData } from './ConfigDiff-slice';
import ViewSummaryDrawer from './ViewSummaryDrawer';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface SummaryData {
  configurationChanges: {
    all_changes: number;
    additions: number;
    deletions: number;
    modified: number;
  };
  vulnerabilityChanges: {
    total_changes: number;
    added: number;
    removed: number;
  };
  cveChanges: {
    total_count: number;
    added: number;
    removed: number;
  };
}

export interface CVEData {
  cve_id: string;
  asset_count: number;
  description: string;
  cisas_kev: string;
  epss: string;
  version: string;
  score: string;
  vector_string: string;
  severity: string;
  cvss_data: Array<{
    score: number;
    vector_string: string;
    severity: string;
    version: string;
  }>;
  cve_issued_date: string;
  cve_last_updated: string;
  summaryData?: {
    cve_summary: string;
    cve_details: {
      vulnerability_name: string | null;
      date_added: string | null;
      due_date: string | null;
      required_action: string | null;
    };
    nvd_pd: string;
    nvd_lmd: string;
    source: string;
    severity: string;
    vulnerability_details: {
      authority: string[];
      attack_vector: string;
      confedentiality_impact: string;
      attack_complexity: string;
      integrity_impact: string;
      privileges_required: string;
      availability_impact: string;
      user_interaction: string;
      scope: string;
      cvss_score: number;
      cisco_data_flag: boolean;
      cisco_data: {
        attack_vector: string;
        confedentiality_impact: string;
        attack_complexity: string;
        integrity_impact: string;
        privileges_required: string;
        availability_impact: string;
        user_interaction: string;
        scope: string;
        cvss_score: number;
        severity: string;
      };
      epss_details: {
        pea: number;
        pov: number;
      };
    };
    reference: Array<{
      hyperlinks: {
        label: string;
        link: string;
        resources: string;
      };
    }>;
    weakness_enumeration: Array<{
      cwe_id: string;
      cwe_name: string;
      source: string;
    }>;
    known_affected_sc: Array<{
      cpe: string;
      to?: string;
      to_include?: boolean;
    }>;
    cisa_data_available: boolean;
    epss_data_available: boolean;
  };
}

interface ScanDate {
  date_added: string;
  file_id?: string;
  id?: number;
  security_score?: number;
  timeStamp?: string;
  [key: string]: any;
}

const ShowConfigDiffPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Read from Redux store
  const configDiffState = useSelector((state: RootState) => state.configDiff);

  // Extract values from Redux state
  const click = configDiffState?.click;
  console.log("click", click);

  const compareRows = configDiffState?.selectedRows ?? null;
  console.log(compareRows, ">>>>>>>>>>>>>>>>>>>.compare rows");
  const rowData = compareRows ? null : configDiffState?.rowData;
  console.log(rowData, ">>>>>>>>>>>>>>>>>>>.row data");
  console.log(configDiffState, ">>>>>>>>>>>>>>>>>>>.configDiff state");
  const deviceIdFromState =
    configDiffState?.device_id ||
    compareRows?.[0]?.device_id ||
    rowData?.asset_id ||
    rowData?.id?.toString() ||
    rowData?.assetName ||
    '';
  const [loading, setLoading] = useState(true);
  const [configDiff, setConfigDiff] = useState<string>('');
  const [configDiffModified, setConfigDiffModified] = useState<string>('');
  const [leftTimestamp, setLeftTimestamp] = useState<string>('');
  const [rightTimestamp, setRightTimestamp] = useState<string>('');
  const [leftSecurityScore, setLeftSecurityScore] = useState<number | null>(null);
  const [rightSecurityScore, setRightSecurityScore] = useState<number | null>(null);
  const [scannedDates, setScannedDates] = useState<ScanDate[]>([]);
  const [selectedScan1, setSelectedScan1] = useState<any | null>(null);
  const [selectedScan2, setSelectedScan2] = useState<any | null>(null);
  const [diffResult, setDiffResult] = useState({
    total: 0,
    additions: 0,
    deletions: 0,
    modified: 0,
  });
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [changes, setChanges] = useState<any[]>([]);
  const diffEditorRef = useRef<editor.IStandaloneDiffEditor | null>(null);
  const isDarkMode = theme.palette.mode === 'dark';
  const [initialPosition, setInitialPosition] = useState(0);
  const [isSingleView, setIsSingleView] = useState(false);
  const [singleConfigContent, setSingleConfigContent] = useState<string>('');
  const [assetSummary, setAssetSummary] = useState<any>(null);
  const [summaryDataLoading, setSummaryDataLoading] = useState(false);
  const [isSummaryDrawerOpen, setIsSummaryDrawerOpen] = useState(false);
  // const customSortOrder = ["Critical", "High", "Medium", "Low"];

  // useEffect(() => {
  //   const hasCompareRows = Boolean(compareRows?.length);

  //   if (hasCompareRows && compareRows && click !== "event-config-diff") {
  //     // Sort compareRows by date to ensure older date is on left, newer date is on right
  //     const sortedRows = [...compareRows].sort((a, b) => {
  //       const dateA = new Date(a.date_added || a.timeStamp || 0).getTime();
  //       const dateB = new Date(b.date_added || b.timeStamp || 0).getTime();
  //       return dateA - dateB; // Ascending order: older first (left), newer second (right)
  //     });
  //     const [scan1, scan2] = sortedRows;
  //     setSelectedScan1(scan1 || null);
  //     setSelectedScan2(scan2 || null);

  //     const hasValidPair =
  //       Boolean(scan1?.file_id) &&
  //       Boolean(scan2?.file_id) &&
  //       scan1?.file_id !== scan2?.file_id;

  //     setIsSingleView(!hasValidPair);
  //     setLeftTimestamp(scan1?.date_added || scan1?.timeStamp || '');
  //     setRightTimestamp(scan2?.date_added || scan2?.timeStamp || '');
  //     setLeftSecurityScore(scan1?.security_score ?? null);
  //     setRightSecurityScore(scan2?.security_score ?? null);
  //   } else if(hasCompareRows && compareRows && click == "event-config-diff") {
  //     const [scanDates1, scanDates2] = await Promise.all([
  //       fetchScanDeviceDates(compareRows[0]?.device_id),
  //       fetchScanDeviceDates(compareRows[1]?.device_id),
  //     ]);

  //     console.log("Device 1 scans:", scanDates1);
  //     console.log("Device 2 scans:", scanDates2);

  //   }

  //   if (deviceIdFromState) {
  //     fetchScanDeviceDates(deviceIdFromState);
  //     return;
  //   }

  //   if (!hasCompareRows && rowData) {
  //     if (rowData.file_id) {
  //       fetchConfigData();
  //     } else {
  //       console.error('No device_id or file_id provided');
  //       setLoading(false);
  //     }
  //     return;
  //   }

  //   if (!hasCompareRows) {
  //     console.error('No row data provided');
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [compareRows, deviceIdFromState, rowData]);

  useEffect(() => {
    const runEffect = async () => {
      const hasCompareRows = Boolean(compareRows?.length);

      if (hasCompareRows && click !== "event-config-diff" && Array.isArray(compareRows)) {
        // Helper function to parse dates - supports ISO format and custom formats
        const parseDate = (dateStr: string | undefined): number => {
          if (!dateStr) return 0;

          // Standard Date parsing works for ISO format like "2025-11-14T11:14:24.031Z"
          const parsed = new Date(dateStr).getTime();
          if (!isNaN(parsed)) return parsed;

          // Fallback: Try parsing custom format "DD Mon, YYYY - HH:MM:SS"
          const match = dateStr.match(/(\d{1,2})\s+(\w+),?\s+(\d{4})\s*-?\s*(\d{1,2}):(\d{2}):?(\d{2})?/);
          if (match) {
            const [, day, monthStr, year, hours, minutes, seconds = '0'] = match;
            const monthMap: { [key: string]: number } = {
              'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
              'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
            };
            const month = monthMap[monthStr] ?? 0;
            return new Date(parseInt(year), month, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds)).getTime();
          }

          return 0;
        };

        // Sort scans by timestamp: older on left, newer on right
        const sortedRows = [...compareRows].sort((a, b) => {
          const dateA = parseDate(a?.timestamp || a?.date_added || a?.timeStamp);
          const dateB = parseDate(b?.timestamp || b?.date_added || b?.timeStamp);
          return dateA - dateB; // Ascending order: older first (left), newer second (right)
        });

        const [scan1, scan2] = sortedRows; // scan1 = older (left), scan2 = newer (right)

        setSelectedScan1(scan1 || null);
        setSelectedScan2(scan2 || null);

        const hasValidPair =
          Boolean(scan1?.file_id) &&
          Boolean(scan2?.file_id) &&
          scan1.file_id !== scan2.file_id;

        setIsSingleView(!hasValidPair);
        setLeftTimestamp(scan1?.date_added || scan1?.timestamp || scan1?.timeStamp || "");
        setRightTimestamp(scan2?.date_added || scan2?.timestamp || scan2?.timeStamp || "");
        setLeftSecurityScore(scan1?.security_score ?? null);
        setRightSecurityScore(scan2?.security_score ?? null);

        return;
      }

      // ✅ FIXED ASYNC PART
      if (hasCompareRows && click === "event-config-diff" && compareRows && compareRows.length >= 2) {
        const assetId1 = compareRows[0]?.asset_id;
        const assetId2 = compareRows[1]?.asset_id;

        if (!assetId1 || !assetId2) {
          console.warn("Missing asset_id for event-config-diff compare rows");
          return;
        }

        const [scanDates1, scanDates2] = await Promise.all([
          fetchScanDeviceDates2(compareRows[0]),
          fetchScanDeviceDates2(compareRows[1]),
        ]);

        console.log("Device 1 scans:", scanDates1);
        console.log("Device 2 scans:", scanDates2);
        if (scanDates1.length >= 1 && scanDates2.length >= 1) {
          const rawScan1 = scanDates1[0];
          const rawScan2 = scanDates2[0];

          // Helper function to parse dates - supports ISO format and custom formats
          const parseDate = (dateStr: string | undefined): number => {
            if (!dateStr) return 0;

            // Standard Date parsing works for ISO format like "2025-11-14T11:14:24.031Z"
            const parsed = new Date(dateStr).getTime();
            if (!isNaN(parsed)) return parsed;

            // Fallback: Try parsing custom format "DD Mon, YYYY - HH:MM:SS"
            const match = dateStr.match(/(\d{1,2})\s+(\w+),?\s+(\d{4})\s*-?\s*(\d{1,2}):(\d{2}):?(\d{2})?/);
            if (match) {
              const [, day, monthStr, year, hours, minutes, seconds = '0'] = match;
              const monthMap: { [key: string]: number } = {
                'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
                'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
              };
              const month = monthMap[monthStr] ?? 0;
              return new Date(parseInt(year), month, parseInt(day), parseInt(hours), parseInt(minutes), parseInt(seconds)).getTime();
            }

            return 0;
          };

          // Sort scans by timestamp: older on left, newer on right
          // Check for 'timestamp' (lowercase from API), 'date_added', or 'timeStamp' fields
          const scansToSort = [rawScan1, rawScan2];
          scansToSort.sort((a, b) => {
            const dateA = parseDate(a?.timestamp || a?.date_added || a?.timeStamp);
            const dateB = parseDate(b?.timestamp || b?.date_added || b?.timeStamp);
            return dateA - dateB; // Ascending order: older first (left), newer second (right)
          });

          const [scan1, scan2] = scansToSort; // scan1 = older (left), scan2 = newer (right)

          setSelectedScan1(scan1 || null);
          setSelectedScan2(scan2 || null);


          const hasValidPair =
            Boolean(scan1?.file_id) &&
            Boolean(scan2?.file_id) &&
            scan1.file_id !== scan2.file_id;

          setIsSingleView(!hasValidPair);
          setLeftTimestamp(scan1?.date_added || scan1?.timestamp || scan1?.timeStamp || "");
          setRightTimestamp(scan2?.date_added || scan2?.timestamp || scan2?.timeStamp || "");
          setLeftSecurityScore(scan1?.security_score ?? null);
          setRightSecurityScore(scan2?.security_score ?? null);
        }
        return;
      }

      if (deviceIdFromState) {
        await fetchScanDeviceDates(deviceIdFromState);
        return;
      }

      if (!hasCompareRows && rowData) {
        if (rowData.file_id) {
          fetchConfigData();
        } else {
          console.error("No device_id or file_id provided");
          setLoading(false);
        }
        return;
      }

      if (!hasCompareRows) {
        console.error("No row data provided");
        setLoading(false);
      }
    };

    runEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareRows, deviceIdFromState, rowData, click]);

  useEffect(() => {
    // When scans are selected, fetch config data
    if (
      selectedScan1 &&
      selectedScan1.file_id &&
      (!selectedScan2 || selectedScan2.file_id)
    ) {
      fetchConfigData();
    } else if (selectedScan1 && selectedScan2 && (!selectedScan1.file_id || !selectedScan2.file_id)) {
      // If scans are set but missing file_ids, stop loading
      console.warn('Selected scans are missing file_ids');
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedScan1, selectedScan2]);

  useEffect(() => {
    // Extract changes when content is updated
    let timeoutId: NodeJS.Timeout | null = null;
    if (configDiff && configDiffModified && diffEditorRef.current) {
      timeoutId = setTimeout(() => {
        // Check if editor still exists before extracting changes
        if (diffEditorRef.current) {
          extractChanges();
        }
      }, 500);
    }
    // Cleanup timeout on unmount or dependency change
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configDiff, configDiffModified]);


  const fetchScanDeviceDates2 = async (asset: any) => {
    try {
      setLoading(true);

      const end_date = format(new Date(), "yyyy-MM-dd");
      const start_date = format(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        "yyyy-MM-dd"
      );

      const response = await axiosInstance.post(
        END_POINTS.DEVICE_CYBER_RESILIENCE_SCAN_DATES,
        {
          device_id: asset.asset_id,
          scan_id: asset.scan_id,
          duration: "custom_date_range",
          start_date,
          end_date,
        }
      );

      if (response?.status === 200 && Array.isArray(response?.data?.data)) {
        return response.data.data; // ✅ always return array
      }

      return []; // ✅ fallback
    } catch (error) {
      console.error("fetchScanDeviceDates failed:", error);
      return []; // ✅ safe fallback
    } finally {
      setLoading(false); // ✅ always stop loader
    }
  };

  const fetchScanDeviceDates = async (device_id: string) => {
    try {
      setLoading(true);
      const end_date = format(new Date(), "yyyy-MM-dd");
      const start_date = format(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
        "yyyy-MM-dd"
      );



      const response = await axiosInstance.post(
        END_POINTS.DEVICE_CYBER_RESILIENCE_SCAN_DATES,
        {
          device_id,
          duration: "custom_date_range",
          start_date,
          end_date,
        }
      );

      if (response?.status === 200 && response?.data?.data?.length > 0) {
        setScannedDates(response?.data?.data);

        const hasExplicitSelection = Array.isArray(compareRows) && compareRows.length > 0;
        if (hasExplicitSelection) {
          setLoading(false);
          return;
        }

        //const scanDates = await fetchScanDeviceDates(deviceIdFromState);
        if (click == "event-config-diff") {

          console.log(response.data.data)
          console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
          console.log(rowData, ">>>>>>>>>>>>>>>>>>>>>>>>>")
          const apiList = response.data.data;
          const scanId = rowData?.scan_id;

          // Find matching index
          const matchedIndex = apiList.findIndex(
            (item: any) => item.id === scanId
          );

          // Final list starting from the next row
          const finalList =
            matchedIndex !== -1 ? apiList.slice(matchedIndex) : [];

          console.log("Final List:", finalList);
          if (finalList.length == 1) {
            const scan1 = finalList[0];
            setSelectedScan1(scan1);
            setSelectedScan2(null);
            setIsSingleView(true);
            setLeftTimestamp(scan1?.date_added || scan1?.timeStamp || '');
            setRightTimestamp('');
            setLeftSecurityScore(scan1?.security_score || null);
            setRightSecurityScore(null);
          } else if (finalList.length >= 2) {
            const scan2 = finalList[0]; // Older scan (left)
            const scan1 = finalList[1]; // Newer scan (right)
            setSelectedScan1(scan1);
            setSelectedScan2(scan2);
            setIsSingleView(false);
            setLeftTimestamp(scan1?.date_added || scan1?.timeStamp || '');
            setRightTimestamp(scan2?.date_added || scan2?.timeStamp || '');
            setLeftSecurityScore(scan1?.security_score || null);
            setRightSecurityScore(scan2?.security_score || null);

          }

        }

        // Default to latest two scans if available
        //
        if (rowData?.previous_file == null && click !== "event-config-diff") {
          const scan1 = rowData;
          setSelectedScan1(scan1);
          setSelectedScan2(null);
          setIsSingleView(true);
          setLeftTimestamp(scan1?.date_added || scan1?.timeStamp || '');
          setRightTimestamp('');
          setLeftSecurityScore(scan1?.security_score || null);
          setRightSecurityScore(null);
          // Note: Don't set loading to false here - fetchConfigData will handle it
        } else if (rowData?.previous_file != null && click !== "event-config-diff") {
          // previous_file is the OLDER scan (left), rowData is the NEWER scan (right)
          const scan1 = rowData.previous_file; // Older scan (left)
          const scan2 = rowData; // Newer scan (right)
          setSelectedScan1(scan1);
          setSelectedScan2(scan2);
          setIsSingleView(false);
          setLeftTimestamp(scan1?.date_added || scan1?.timeStamp || '');
          setRightTimestamp(scan2?.date_added || scan2?.timeStamp || '');
          setLeftSecurityScore(scan1?.security_score || null);
          setRightSecurityScore(scan2?.security_score || null);
          // Note: Don't set loading to false here - fetchConfigData will handle it
        } else {
          // No scans available
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching scanned device dates:", error);
      setLoading(false);
    }
  };

  const fetchConfigData = async () => {
    try {
      setLoading(true);

      // Use file_ids from selected scans (required)
      const fileId1 = selectedScan1?.file_id;
      const fileId2 = selectedScan2?.file_id;

      // Fallback to rowData if scans not available
      const finalFileId1 = fileId1
      const finalFileId2 =
        fileId2

      if (!finalFileId1) {
        console.error('No file_id found for config diff');
        setLoading(false);
        return;
      }

      const shouldCompare = Boolean(finalFileId2) && finalFileId2 !== finalFileId1;

      if (!shouldCompare) {
        // Single scan available - show single view
        setIsSingleView(true);
        const singleResponse = await axiosInstance.post(END_POINTS.CONFIG_DIFF, {
          file_id1: finalFileId1,
        });

        if (singleResponse?.status === 200) {
          const content = singleResponse?.data?.data?.content1?.join('\n') || '';
          setSingleConfigContent(content);
          setConfigDiff('');
          setConfigDiffModified('');
          setDiffResult({ total: 0, additions: 0, deletions: 0, modified: 0 });
          if (selectedScan1) {
            setLeftTimestamp(selectedScan1.date_added || selectedScan1.timeStamp || '');
            setLeftSecurityScore(selectedScan1.security_score || null);
          } else if (rowData) {
            setLeftTimestamp(rowData.timeStamp || '');
            setLeftSecurityScore(rowData.security_score || null);
          }
          setRightTimestamp('');
          setRightSecurityScore(null);
        }
        setLoading(false);
        return;
      }

      setIsSingleView(false);
      const [diffResponse, diffModifiedResponse] = await Promise.all([
        axiosInstance.post(END_POINTS.CONFIG_DIFF, {
          file_id1: finalFileId1,
        }),
        axiosInstance.post(END_POINTS.CONFIG_DIFF_MODIFIED, {
          file_id2: finalFileId2,
        }),
      ]);

      if (
        diffResponse?.status === 200 &&
        diffModifiedResponse?.status === 200
      ) {
        const content1 = diffResponse?.data?.data?.content1?.join("\n") || '';
        const content2 = diffModifiedResponse?.data?.data?.content2?.join("\n") || '';

        setConfigDiff(content1);
        setConfigDiffModified(content2);
        setSingleConfigContent('');

        // Update timestamps and security scores from selected scans
        if (selectedScan1 && selectedScan2) {
          setLeftTimestamp(selectedScan1.date_added || selectedScan1.timeStamp || '');
          setRightTimestamp(selectedScan2.date_added || selectedScan2.timeStamp || '');
          setLeftSecurityScore(selectedScan1.security_score || null);
          setRightSecurityScore(selectedScan2.security_score || null);
        } else if (rowData) {
          // Fallback to rowData
          const previousTimestamp = rowData.previous_timeStamp || rowData.timeStamp || '';
          setLeftTimestamp(previousTimestamp);
          setRightTimestamp(rowData.timeStamp || '');
          setLeftSecurityScore(rowData.previous_security_score || rowData.security_score || null);
          setRightSecurityScore(rowData.security_score || null);
        }

        calculateDiffCounts(content1, content2);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching config data:", error);
      setLoading(false);
    }
  };

  const calculateDiffCounts = (content1: string, content2: string) => {
    if (!content1 || !content2) {
      setDiffResult({ total: 0, additions: 0, deletions: 0, modified: 0 });
      return;
    }

    const lines1 = content1.split('\n').filter((line: string) => line.trim() !== '');
    const lines2 = content2.split('\n').filter((line: string) => line.trim() !== '');

    let additions = 0;
    let deletions = 0;
    let modified = 0;

    const map1 = new Map<string, number>();
    const map2 = new Map<string, number>();

    lines1.forEach((line: string) => {
      map1.set(line, (map1.get(line) || 0) + 1);
    });

    lines2.forEach((line: string) => {
      map2.set(line, (map2.get(line) || 0) + 1);
    });

    map1.forEach((count, line) => {
      const count2 = map2.get(line) || 0;
      if (count2 === 0) {
        deletions += count;
      } else if (count !== count2) {
        modified += Math.abs(count - count2);
      }
    });

    map2.forEach((count, line) => {
      if (!map1.has(line)) {
        additions += count;
      }
    });

    const total = additions + deletions + modified;
    setDiffResult({ total, additions, deletions, modified });
  };

  const extractChanges = () => {
    if (!diffEditorRef.current) {
      return;
    }
    try {
      const diffEditor = diffEditorRef.current;
      const lineChanges = diffEditor.getLineChanges();

      if (!lineChanges || lineChanges.length === 0) {
        setChanges([]);
        setCurrentIndex(-1);
        return;
      }

      let added = 0;
      let removed = 0;
      let modified = 0;

      lineChanges.forEach((change: any) => {
        const originalLength = change.originalEndLineNumber - change.originalStartLineNumber + 1;
        const modifiedLength = change.modifiedEndLineNumber - change.modifiedStartLineNumber + 1;

        if (change.originalEndLineNumber === 0) {
          added += modifiedLength;
        } else if (change.modifiedEndLineNumber === 0) {
          removed += originalLength;
        } else {
          modified += Math.max(originalLength, modifiedLength);
        }
      });

      const newChanges = lineChanges.map((change: any) => ({
        modifiedStart: change.modifiedStartLineNumber,
        modifiedEnd: change.modifiedEndLineNumber,
      }));

      setChanges(newChanges);
      setCurrentIndex(newChanges.length ? -1 : 0);

      // Note: initialPosition is stored but not currently used
      // const modifiedEditor = diffEditor.getModifiedEditor();
      // if (modifiedEditor) {
      //   const scrollTop = modifiedEditor.getScrollTop();
      //   setInitialPosition(scrollTop || 0);
      // }
      const modifiedEditor = diffEditor.getModifiedEditor();
      if (modifiedEditor) {
        const scrollTop = modifiedEditor.getScrollTop();
        setInitialPosition(scrollTop || 0);
      }
    } catch (error) {
      console.error("Error extracting changes:", error);
    }
  };

  const scrollToChange = (index: number) => {
    const modifiedEditor = diffEditorRef.current?.getModifiedEditor?.();
    if (!modifiedEditor || !changes.length) return;
    modifiedEditor.revealLineInCenter(changes[index].modifiedStart);
  };

  const scrollToInitialPosition = () => {
    const modifiedEditor = diffEditorRef.current?.getModifiedEditor?.();
    if (modifiedEditor) modifiedEditor.setScrollTop(initialPosition);
  };

  const handleNext = () => {
    if (!changes.length) return;
    const nextIndex = currentIndex + 1;
    if (nextIndex < changes.length) {
      setCurrentIndex(nextIndex);
      scrollToChange(nextIndex);
    }
  };

  const handlePrev = () => {
    if (!changes.length) return;
    if (currentIndex <= 0) {
      setCurrentIndex(-1);
      scrollToInitialPosition();
    } else {
      const prevIndex = currentIndex - 1;
      setCurrentIndex(prevIndex);
      scrollToChange(prevIndex);
    }
  };

  useEffect(() => {
    // Reset the navigation when diff content updates
    setCurrentIndex(-1);
    setChanges([]);
  }, [configDiff, configDiffModified]);

  // Cleanup Monaco editor on unmount to prevent disposal errors
  useEffect(() => {
    return () => {
      // Dispose the diff editor reference on unmount
      if (diffEditorRef.current) {
        try {
          // Clear the reference first to prevent accessing disposed editor
          const editor = diffEditorRef.current;
          diffEditorRef.current = null;
          // Dispose the editor models properly
          editor.dispose();
        } catch (e) {
          // Silently catch disposal errors - editor might already be disposed
          console.debug('Monaco editor cleanup:', e);
        }
      }
    };
  }, []);

  const handleBack = () => {
    dispatch(clearConfigDiffData());

    if (click === 'event-config-diff') {
      // Events tab flow: navigate explicitly so we can pass the device context back.
      // Using eventDeviceId (separate key from device_id) so ConfigDiff restores
      // selectedDevice without triggering single-asset mode.
      navigate('/on-premises/configdiff', {
        state: {
          activeTab: 1,
          eventDeviceId: deviceIdFromState || undefined,
        },
      });
    } else {
      // Assets tab / asset-management flow: navigate(-1) naturally restores the right view.
      navigate(-1);
    }
  };

  const fetchScanChangesData = async (
    asset_id: string,
    scan_id: string,
    file_id1?: string,
    file_id2?: string
  ) => {
    try {
      const response = await axiosInstance.get(END_POINTS.FILE_SUMMARY, {
        params: {
          asset_id,
          scan_id,
          file_id1,
          file_id2,
        },
      });

      if (response?.data?.status !== 200) return;

      const scans = response.data?.data?.scans || [];

      // ✅ Pick scan where is_first_scan === false
      const selectedScan =
        scans.find((scan: any) => scan.is_first_scan === false) ||
        scans[0]; // fallback safety

      if (!selectedScan) return;

      // ✅ Pass ONLY required summary data
      setAssetSummary({
        configuration_changes: selectedScan.configuration_changes ?? {},
        vulnerability_summary: selectedScan.misconfiguration_changes ?? {},
        vulnerability_changes: selectedScan.misconfiguration_changes_detailed ?? [],
        cve_summary: selectedScan.cve_changes ?? {},
        cve_changes: selectedScan.cve_changes_detailed ?? [],
      });
    } catch (error) {
      console.error("Error fetching file summary:", error);
    }
  };

  const toSignedNumber = (val: any): number => {
    if (val === null || val === undefined) return 0;
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const num = Number(val.replace("+", ""));
      return isNaN(num) ? 0 : num;
    }
    return 0;
  };

  const summaryData = useMemo(() => {
    const config = assetSummary?.configuration_changes ?? {};
    const vuln = assetSummary?.vulnerability_summary ?? {};
    const cve = assetSummary?.cve_summary ?? {};

    return {
      configurationChanges: {
        all_changes: toSignedNumber(config.all_changes),
        additions: toSignedNumber(config.additions),
        deletions: toSignedNumber(config.deletions),
        modified: toSignedNumber(config.modified),
      },

      vulnerabilityChanges: {
        total_changes: toSignedNumber(vuln.total_changes),
        added: toSignedNumber(vuln.added),
        removed: toSignedNumber(vuln.removed),
      },

      cveChanges: {
        total_count: toSignedNumber(cve.total_count),
        added: toSignedNumber(cve.added),
        removed: toSignedNumber(cve.removed),
      },

      misconfigurationChanges: assetSummary?.vulnerability_changes || [],
      cves: assetSummary?.cve_changes || [],
    };
  }, [assetSummary]);

  const handleOpenSummary = async () => {
    const assetId = deviceIdFromState;
    const scanId = selectedScan1?.scan_id || rowData?.scan_id;
    setSummaryDataLoading(true);

    try {
      await fetchScanChangesData(
        assetId,
        scanId,
        selectedScan1?.file_id,
        selectedScan2?.file_id
      );
      setIsSummaryDrawerOpen(true);
    } catch (error) {
      console.error("Error loading summary:", error);
    } finally {
      setSummaryDataLoading(false);
    }
  };

  const handleCloseSummary = () => {
    setIsSummaryDrawerOpen(false);
  };

  const getSecurityScoreColor = (score: number | null) => {
    if (score === null) return '#000000';
    if (score < 50) return '#B61111'; // Red
    if (score <= 80) return '#E85800'; // Yellow
    return '#00A61B'; // Green
  };

  const refreshSummaryIfOpen = async (
    scan1: any,
    scan2: any
  ) => {
    if (!isSummaryDrawerOpen) return;

    const assetId = deviceIdFromState;
    const scanId = scan1?.scan_id || rowData?.scan_id;

    if (!assetId || !scanId) return;

    setSummaryDataLoading(true);
    try {
      await fetchScanChangesData(
        assetId,
        scanId,
        scan1?.file_id,
        scan2?.file_id
      );
    } finally {
      setSummaryDataLoading(false);
    }
  };

  const handleLeftDateChange = async (dateAdded: string) => {
    // Find the selected date in scannedDates array
    const selectedIndex = scannedDates.findIndex((d) => d.date_added === dateAdded);
    if (selectedIndex === -1) return;

    const selectedScan = scannedDates[selectedIndex];

    // scannedDates is sorted from newest (index 0) to oldest (last index)
    // The immediate previous scan is at index + 1 (older date)
    const previousScanIndex = selectedIndex + 1;
    const previousScan = previousScanIndex < scannedDates.length ? scannedDates[previousScanIndex] : null;

    // When in single view OR when we need to set up proper comparison
    // We always want: previous (older) on left, selected (newer) on right
    if (previousScan) {
      // Has previous scan - set up comparison view
      setSelectedScan1(previousScan);  // Left = older/previous
      setSelectedScan2(selectedScan);   // Right = newer/selected
      setIsSingleView(false);
      setLeftTimestamp(previousScan.date_added || previousScan.timeStamp || '');
      setLeftSecurityScore(previousScan.security_score || null);
      setRightTimestamp(selectedScan.date_added || selectedScan.timeStamp || '');
      setRightSecurityScore(selectedScan.security_score || null);

      // ✅ refresh FILE_SUMMARY with new file_ids
      await refreshSummaryIfOpen(previousScan, selectedScan);
    } else {
      // No previous scan (oldest date selected) - single view
      setSelectedScan1(selectedScan);
      setSelectedScan2(null);
      setIsSingleView(true);
      setLeftTimestamp(selectedScan.date_added || selectedScan.timeStamp || '');
      setLeftSecurityScore(selectedScan.security_score || null);
      setRightTimestamp('');
      setRightSecurityScore(null);

      // ✅ refresh FILE_SUMMARY with new file_id1
      await refreshSummaryIfOpen(selectedScan, null);
    }
  };

  const handleRightDateChange = async (dateAdded: string) => {
    // Find the selected date in scannedDates array
    const selectedIndex = scannedDates.findIndex((d) => d.date_added === dateAdded);
    if (selectedIndex === -1) return;

    const selectedScan = scannedDates[selectedIndex];

    // scannedDates is sorted from newest (index 0) to oldest (last index)
    // The immediate previous scan is at index + 1 (older date)
    const previousScanIndex = selectedIndex + 1;
    const previousScan = previousScanIndex < scannedDates.length ? scannedDates[previousScanIndex] : null;

    if (previousScan) {
      // Has previous scan - set up comparison: previous (left), selected (right)
      setSelectedScan1(previousScan);  // Left = older/previous
      setSelectedScan2(selectedScan);   // Right = newer/selected
      setIsSingleView(false);
      setLeftTimestamp(previousScan.date_added || previousScan.timeStamp || '');
      setLeftSecurityScore(previousScan.security_score || null);
      setRightTimestamp(selectedScan.date_added || selectedScan.timeStamp || '');
      setRightSecurityScore(selectedScan.security_score || null);

      // ✅ refresh FILE_SUMMARY with new file_ids
      await refreshSummaryIfOpen(previousScan, selectedScan);
    } else {
      // No previous scan (oldest date selected) - switch to single view
      setSelectedScan1(selectedScan);
      setSelectedScan2(null);
      setIsSingleView(true);
      setLeftTimestamp(selectedScan.date_added || selectedScan.timeStamp || '');
      setLeftSecurityScore(selectedScan.security_score || null);
      setRightTimestamp('');
      setRightSecurityScore(null);

      // ✅ refresh FILE_SUMMARY with single file_id
      await refreshSummaryIfOpen(selectedScan, null);
    }
  };

  const showViewSummary = useMemo(() => {
    if (!selectedScan1?.file_id) return false;
    if (!selectedScan2?.file_id) return false;
    if (selectedScan1.file_id === selectedScan2.file_id) return false;
    if (isSingleView) return false;
    return true;
  }, [selectedScan1, selectedScan2, isSingleView]);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      bgcolor: 'background.default',
      margin: -3,
      p: 1
    }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: `1px solid ${theme.palette.divider}`,
          mb: 2,
          gap: 1
        }}
      >
        <IconButton onClick={handleBack} aria-label="back">
          <ArrowBackIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <span style={{ fontWeight: 700, fontSize: "16px" }}>
          Show Configuration
        </span>
        <Box sx={{ flex: 1 }} />
        {showViewSummary && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleOpenSummary}
            disabled={loading}
          >
            View Summary
          </Button>
        )}
      </Box>

      {loading ? (
        <Box sx={{ p: 2 }}>
          {/* Header skeleton */}
          <Skeleton variant="rectangular" height={48} sx={{ mb: 2 }} />

          {/* Date selectors skeleton */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Skeleton variant="rectangular" height={40} width={250} />
            <Skeleton variant="rectangular" height={20} width={120} />
            <Skeleton variant="rectangular" height={40} width={250} />
            <Skeleton variant="rectangular" height={20} width={120} />
          </Box>

          {/* Diff indicator bar */}
          <Skeleton variant="rectangular" height={32} sx={{ mb: 1 }} />

          {/* Editor area skeleton */}
          <Skeleton
            variant="rectangular"
            height="60vh"
            sx={{ borderRadius: 1 }}
          />
        </Box>
      ) : (
        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {/* Header with Timestamps and Security Scores */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1.5,
            bgcolor: isDarkMode ? '#1E1E1E' : '#F2F1FE',
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <FormControl
                size="small"
                sx={{
                  minWidth: 250,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: isDarkMode ? '#1E1E1E' : '#fff',
                    color: isDarkMode ? '#fff' : '#000',
                  }
                }}
              >
                <Select
                  value={selectedScan1?.date_added || ''}
                  onChange={(e) => handleLeftDateChange(e.target.value)}
                  displayEmpty
                  renderValue={(value) => {
                    if (!value && scannedDates.length === 0) {
                      return leftTimestamp || 'No dates available';
                    }
                    const selectedDate = scannedDates.find(d => d.date_added === value);
                    return selectedDate ? selectedDate.date_added : leftTimestamp || 'Select date';
                  }}
                  sx={{
                    fontSize: '0.875rem',
                    '& .MuiSelect-select': {
                      py: 1,
                    }
                  }}
                >
                  {scannedDates.length === 0 ? (
                    <MenuItem value="">
                      <Typography variant="subtitle2" sx={{ color: isDarkMode ? '#fff' : '#8480AD' }}>
                        {leftTimestamp || 'No dates available'}
                      </Typography>
                    </MenuItem>
                  ) : (
                    scannedDates.map((date) => (
                      <MenuItem key={date.date_added} value={date.date_added}>
                        {date.date_added}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
              <span style={{ fontWeight: 500, fontSize: "13px" }}>
                Security Score:{' '}
                <span style={{
                  color: getSecurityScoreColor(leftSecurityScore),
                  marginLeft: '4px',
                  fontWeight: 'bold',
                }}>
                  {leftSecurityScore !== null ? leftSecurityScore.toFixed(1) : '-'}
                </span>
              </span>
            </Box>
            {!isSingleView && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <FormControl
                  size="small"
                  sx={{
                    minWidth: 250,
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: isDarkMode ? '#1E1E1E' : '#fff',
                      color: isDarkMode ? '#fff' : '#000',
                    }
                  }}
                >
                  <Select
                    value={selectedScan2?.date_added || ''}
                    onChange={(e) => handleRightDateChange(e.target.value)}
                    displayEmpty
                    renderValue={(value) => {
                      if (!value && scannedDates.length === 0) {
                        return rightTimestamp || 'No dates available';
                      }
                      const selectedDate = scannedDates.find(d => d.date_added === value);
                      return selectedDate ? selectedDate.date_added : rightTimestamp || 'Select date';
                    }}
                    sx={{
                      fontSize: '0.875rem',
                      '& .MuiSelect-select': {
                        py: 1,
                      }
                    }}
                  >
                    {scannedDates.length === 0 ? (
                      <MenuItem value="">
                        <Typography variant="subtitle2" sx={{ color: isDarkMode ? '#fff' : '#8480AD' }}>
                          {rightTimestamp || 'No dates available'}
                        </Typography>
                      </MenuItem>
                    ) : (
                      scannedDates.map((date) => (
                        <MenuItem key={date.date_added} value={date.date_added}>
                          {date.date_added}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
                <span style={{ fontWeight: 500, fontSize: "13px" }}>
                  Security Score:{' '}
                  <span style={{
                    color: getSecurityScoreColor(rightSecurityScore),
                    marginLeft: '4px',
                    fontWeight: 'bold',
                  }}>
                    {rightSecurityScore !== null ? rightSecurityScore.toFixed(1) : '-'}
                  </span>
                </span>
              </Box>
            )}
          </Box>

          {/* Difference Indicator and Navigation */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              // py: 0.5,
              // bgcolor: isDarkMode ? '#1E1E1E' : '#F2F1FE',
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            {/* Left side text */}
            <span
              style={{
                color: '#B61111',
                fontWeight: 700,
                fontSize: '11px',
              }}
            >
              {isSingleView
                ? 'Single configuration view (no comparison available)'
                : `Configuration Difference: ${currentIndex === -1 ? 0 : currentIndex + 1
                } of ${changes.length || diffResult.total}`}
            </span>

            {/* Right side icons */}
            {!isSingleView && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <IconButton
                  size="small"
                  onClick={handlePrev}
                  disabled={currentIndex === -1 || !changes.length}
                  sx={{ color: isDarkMode ? '#fff' : '#000' }}
                >
                  <ExpandLessIcon fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={handleNext}
                  disabled={currentIndex === changes.length - 1 || !changes.length}
                  sx={{ color: isDarkMode ? '#fff' : '#000' }}
                >
                  <ExpandMoreIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box>

          {/* Diff Editor */}
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            {isSingleView ? (
              <Editor
                height="100%"
                width="100%"
                language="plaintext"
                value={singleConfigContent}
                options={{
                  readOnly: true,
                  renderOverviewRuler: false,
                  lineNumbers: 'on',
                  minimap: { enabled: false },
                }}
                theme={isDarkMode ? 'vs-dark' : 'vs'}
              />
            ) : (
              <DiffEditor
                key={`diff-editor-${isDarkMode}`}
                height="100%"
                width="100%"
                language="plaintext"
                original={configDiff}
                modified={configDiffModified}
                options={{
                  readOnly: true,
                  enableSplitViewResizing: true,
                  renderOverviewRuler: false,
                  lineNumbers: 'on',
                  minimap: { enabled: false },
                }}
                onMount={(editor, monaco) => {
                  diffEditorRef.current = editor;

                  const background = isDarkMode ? '1E1E1E' : 'FFFFFF';
                  const foreground = isDarkMode ? 'FFFFFF' : '000000';

                  monaco.editor.defineTheme('custom-theme', {
                    base: isDarkMode ? 'vs-dark' : 'vs',
                    inherit: true,
                    rules: [
                      {
                        token: '',
                        foreground: foreground,
                        background: background,
                      },
                    ],
                    colors: {
                      'editor.background': `#${background}`,
                      'editor.foreground': `#${foreground}`,
                      'diffEditor.insertedTextBackground': isDarkMode ? '#144212' : '#DDFFDD',
                      'diffEditor.removedTextBackground': isDarkMode ? '#601212' : '#FFDDDD',
                    },
                  });

                  monaco.editor.setTheme('custom-theme');

                  // Extract changes after a short delay to ensure editor is fully initialized
                  const checkEditorReady = () => {
                    // Guard: Check if component is still mounted (diffEditorRef not cleared)
                    if (!diffEditorRef.current) {
                      return;
                    }
                    const modifiedEditor = editor.getModifiedEditor();
                    if (modifiedEditor) {
                      editor.onDidUpdateDiff(() => {
                        // Guard: Only extract changes if editor still exists
                        if (diffEditorRef.current) {
                          extractChanges();
                        }
                      });
                      extractChanges();
                    } else {
                      setTimeout(checkEditorReady, 100);
                    }
                  };

                  checkEditorReady();
                }}
              />
            )}
          </Box>
        </Box>
      )}

      <ViewSummaryDrawer
        open={isSummaryDrawerOpen}
        onClose={handleCloseSummary}
        summaryData={summaryData}
        isLoading={summaryDataLoading}
      // vendor={vendor}
      />
    </Box>
  );
};

export default ShowConfigDiffPage;
